import { numberFunctions } from "../../../../../../themes/custom/ev_theme/frontend/js/common/constants/functions/numberFunctions";
import { getNumericValue } from "../../../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { createdNoUiSlider, updateNoUiSlider } from "../../../../../../themes/custom/ev_theme/frontend/js/components/noUiSlider";
import { orderValues } from "../results-load/results-query";
import { data_select, list_filters } from "../results-load/results-state";
import { loadChangeFilters } from "./filters";
const sliders = {
    area: {
        startMin: 0,
        startMax: 560,
        min: 0,
        max: 560,
        start: 40,
        step: 10,
        labelMin: 'Área mínima',
        labelMax: 'Área máxima',
    },
    precio: {
        startMin: 0,
        startMax: 4800,
        min: 0,
        max: 4800,
        start: 40,
        step: 50,
        labelMin: 'Precio mínimo',
        labelMax: 'Precio máximo',
    },
    precio_builder: {
        startMin: 0,
        startMax: 4800,
        min: 0,
        max: 4800,
        start: 40,
        step: 50,
        labelMin: 'Precio mínimo',
        labelMax: 'Precio máximo',
    }
};
export async function loadFiltersSlider(sliderId) {
    initializeSlider(sliderId, (values, handle) => updateFilter(sliderId, values, handle));
}
function initializeSlider(sliderId, updateCallback) {
    const slider = document.getElementById(sliderId);
    slider === null || slider === void 0 ? void 0 : slider.noUiSlider.on('update', updateCallback);
    slider === null || slider === void 0 ? void 0 : slider.noUiSlider.on('end', () => {
        ifProyectsOnRange(sliderId);
    });
}
function updateFilter(sliderId, values, handle) {
    const typeHandle = handle ? 'max' : 'min';
    const valueFilter = parseInt(values[handle]);
    const inputSelector = document.querySelector(`.js-${typeHandle}-range-${sliderId}`);
    inputSelector.value = numberFunctions.addThousandsSeparator(valueFilter.toString());
    if (handle === 0) {
        sliders[sliderId].startMin = valueFilter;
    }
    else {
        sliders[sliderId].startMax = valueFilter;
        // sliders[sliderId].max = valueFilter;
    }
}
export function getValuesUpdated(sliderId) {
    const minRange = document.querySelector(`.js-min-range-${sliderId}`).value;
    const maxRange = document.querySelector(`.js-max-range-${sliderId}`).value;
    sliders[sliderId].startMin = getNumericValue(minRange);
    sliders[sliderId].startMax = getNumericValue(maxRange);
    ifProyectsOnRange(sliderId);
}
/**
 * Sets a small UI hint indicating the step increments used by the range slider.
 * Helps users understand that values snap to configured multiples.
 *
 * @param {'precio' | 'precio_builder' | 'area'} sliderId Slider identifier.
 * @returns {void}
 */
export function setRangeHint(sliderId) {
    const hint = document.querySelector(`.js-range-hint-${sliderId}`);
    if (!hint)
        return;
    const step = sliders[sliderId].step || 10;
    if (sliderId.includes('precio')) {
        hint.textContent = `Los valores se actualizan en múltiplos de ${step} M`;
    }
    else {
        hint.textContent = `Los valores se actualizan en múltiplos de ${step} m²`;
    }
}
/**
 * Binds manual min/max inputs to the range slider.
 * Applies filters after user stops typing and avoids duplicate requests.
 *
 * @param {'precio' | 'precio_builder' | 'area'} sliderId Slider identifier.
 * @returns {void}
 */
export function bindRangeInputs(sliderId) {
    const min = document.querySelector(`.js-min-range-${sliderId}`);
    const max = document.querySelector(`.js-max-range-${sliderId}`);
    const slider = document.getElementById(sliderId);
    if (!min || !max || !(slider === null || slider === void 0 ? void 0 : slider.noUiSlider))
        return;
    if (min.dataset.bound === '1')
        return;
    min.dataset.bound = '1';
    max.dataset.bound = '1';
    const apply = () => getValuesUpdated(sliderId);
    const digitsOnly = (v) => (v || '').replace(/[^\d]/g, '');
    const digitsLen = (el) => digitsOnly(el.value).length;
    let lastAppliedMin = digitsOnly(min.value);
    let lastAppliedMax = digitsOnly(max.value);
    const applyIfChanged = () => {
        const nowMin = digitsOnly(min.value);
        const nowMax = digitsOnly(max.value);
        if (nowMin === lastAppliedMin && nowMax === lastAppliedMax)
            return;
        lastAppliedMin = nowMin;
        lastAppliedMax = nowMax;
        apply();
    };
    let tMin;
    let tMax;
    const minDelay = sliderId.includes('precio') ? 800 : 700;
    const maxDelay = sliderId.includes('precio') ? 1100 : 900;
    min.addEventListener('input', () => {
        window.clearTimeout(tMin);
        if (digitsLen(min) < 2)
            return;
        tMin = window.setTimeout(applyIfChanged, minDelay);
    });
    max.addEventListener('input', () => {
        window.clearTimeout(tMax);
        if (digitsLen(max) < 2)
            return;
        tMax = window.setTimeout(applyIfChanged, maxDelay);
    });
    min.addEventListener('paste', () => {
        window.clearTimeout(tMin);
        tMin = window.setTimeout(applyIfChanged, 150);
    });
    max.addEventListener('paste', () => {
        window.clearTimeout(tMax);
        tMax = window.setTimeout(applyIfChanged, 150);
    });
}
export function ifProyectsOnRange(sliderId) {
    const listKey = sliderId.includes('precio') ? 'precio_list' : 'area_list';
    const templist = list_filters[listKey].filter(x => {
        const filterValue = Number(x.filter);
        return (filterValue / (sliderId.includes('precio') ? 1000000 : 1)) >= sliders[sliderId].startMin && (filterValue / (sliderId.includes('precio') ? 1000000 : 1)) <= sliders[sliderId].startMax;
    });
    if (!templist.length) {
        adjustRange(sliderId, sliders[sliderId].min, sliders[sliderId].max);
    }
    updateSlider(sliderId, sliders[sliderId].startMin, sliders[sliderId].startMax);
}
function adjustRange(type, minRange, maxRange) {
    const list = type.includes('precio') ? list_filters.precio_list : list_filters.area_list;
    const lista = [];
    list.forEach(project => {
        const projectFilterNumber = Number(project.filter);
        let value = type.includes('precio') ? (projectFilterNumber / 1000000) - minRange : projectFilterNumber - minRange;
        lista.push({
            label: minRange < projectFilterNumber ? 'MinRange' : 'MaxRange',
            value: Math.abs(value)
        });
    });
    lista.sort((a, b) => a.value - b.value);
    if (lista[0].label === 'MinRange') {
        sliders[type].min = getDowCoutaInterval(minRange, sliders[type].step || 10);
    }
    if (lista[0].label === 'MaxRange') {
        sliders[type].max = getUpCoutaInterval(maxRange, sliders[type].step || 10);
    }
}
function setRange(type, list) {
    var _a, _b, _c;
    const step = ((_a = sliders[type]) === null || _a === void 0 ? void 0 : _a.step) || 10;
    const divisor = type.includes('precio') ? 1000000 : 1;
    const fallbackRanges = {
        precio: { min: 0, max: 1000 },
        precio_builder: { min: 0, max: 1000 },
        area: { min: 0, max: 500 },
    };
    const fallback = fallbackRanges[type];
    if (!Array.isArray(list) || list.length === 0) {
        sliders[type].startMin = fallback.min;
        sliders[type].startMax = fallback.max;
        sliders[type].min = fallback.min;
        sliders[type].max = fallback.max;
        return false;
    }
    const sortedList = [...list].sort((a, b) => Number(a.filter) - Number(b.filter));
    const firstValue = Number((_b = sortedList[0]) === null || _b === void 0 ? void 0 : _b.filter);
    const lastValue = Number((_c = sortedList[sortedList.length - 1]) === null || _c === void 0 ? void 0 : _c.filter);
    if (isNaN(firstValue) || isNaN(lastValue)) {
        sliders[type].startMin = fallback.min;
        sliders[type].startMax = fallback.max;
        sliders[type].min = fallback.min;
        sliders[type].max = fallback.max;
        return false;
    }
    sliders[type].startMin = getDowCoutaInterval(firstValue / divisor, step);
    sliders[type].startMax = getUpCoutaInterval(lastValue / divisor, step);
    sliders[type].min = sliders[type].startMin;
    sliders[type].max = sliders[type].startMax;
    return true;
}
function updateSlider(sliderId, minRange, maxRange) {
    const slider = document.getElementById(sliderId);
    if (!slider)
        return;
    updateNoUiSlider(slider, sliders[sliderId]);
    const isPriceSlider = sliderId.includes('precio');
    const adjustedMinRange = isPriceSlider ? minRange * 1000000 : minRange;
    const adjustedMaxRange = isPriceSlider ? maxRange * 1000000 : maxRange;
    const nameSelect = sliderId.includes('precio') ? 'price' : sliderId;
    data_select[nameSelect][0] = adjustedMinRange;
    data_select[nameSelect][1] = adjustedMaxRange;
    const isBuilder = sliderId === 'precio_builder';
    loadChangeFilters(minRange + ',' + maxRange, sliderId, isBuilder);
}
export function setSlider(type) {
    const slider = document.getElementById(type);
    if (!slider)
        return;
    const listKey = type.includes('precio') ? 'precio_list' : 'area_list';
    const hasValidRange = setRange(type, list_filters[listKey]);
    createdNoUiSlider(slider, sliders[type]);
    if (!hasValidRange) {
        slider.classList.add('is-empty-range');
    }
    else {
        slider.classList.remove('is-empty-range');
    }
}
function getDowCoutaInterval(num, step) {
    return Math.floor(num / step) * step;
}
function getUpCoutaInterval(num, step) {
    return Math.ceil(num / step) * step;
}
export function updateFiltersRange(finalRes) {
    var _a, _b;
    if (!data_select['area'].length) {
        list_filters.area_list = ((_a = finalRes.facetas.area_built) === null || _a === void 0 ? void 0 : _a.length)
            ? orderValues(finalRes.facetas.area_built)
            : [];
        setRange('area', list_filters.area_list);
        const slider = document.getElementById('area');
        if (slider) {
            updateNoUiSlider(slider, sliders['area']);
        }
    }
    if (!data_select['price'].length) {
        list_filters.precio_list = ((_b = finalRes.facetas.typology_price) === null || _b === void 0 ? void 0 : _b.length)
            ? orderValues(finalRes.facetas.typology_price)
            : [];
        setRange('precio', list_filters.precio_list);
        const slider = document.getElementById('precio');
        if (slider) {
            updateNoUiSlider(slider, sliders['precio']);
        }
    }
}
export function clearData() {
    resetSlider('precio');
    resetSlider('area');
}
function resetSlider(sliderId) {
    const slider = document.getElementById(sliderId);
    sliders[sliderId].startMin = sliders[sliderId].min;
    sliders[sliderId].startMax = sliders[sliderId].max;
    if (slider) {
        updateNoUiSlider(slider, sliders[sliderId]);
    }
    document.querySelectorAll(`.value-${sliderId}`).forEach(input => {
        const inputElement = input;
        inputElement.value = '0';
    });
}
